import React, {useEffect} from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css'

// Risk and Warning component

const RiskWarning = () => {
    const { t } = useTranslation();

    useEffect(() => {
      scrollToTop();
    }, []);

    useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
    },[])
    
    return (
        <div style={{ marginTop: '10rem' }}>
            <div className="page-wrapper">
                <Navbar />
                <section className="blog-area">
                    <div className="hero-wrapper hero-7 space" id="hero">
                        <div className="container-space">
                            <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
                                <div className="col-lg-12 col-md-6">
                                    <h3
                                        className="text-center links-heading item-heading-font "
                                        style={{ fontSize: "26px", color: "#ee7c2c" }}
                                    >
                                        {t("riskWarning")}
                                    </h3>
                                    <div className="card-text item-content-font">
                                        <p 
                                            style={{ fontSize: "15px" }}
                                            className="sl_whiteout notranslate"
                                        >
                                            <p className="agreement-para">
                                                <span style={{ fontSize: "16px" }}>
                                                    {t("beforeYouEnter")}
                                                </span>
                                            </p>
                                            <p className="agreement-para">
                                                <span style={{ fontSize: "16px" }}>
                                                    {t("thereforeOurClients")}
                                                </span>
                                            </p>
                                            <p className="agreement-para">
                                                <span style={{ fontSize: "16px" }}>
                                                    {t("theseRisksInclude")}
                                                </span>
                                            </p>
                                            <p className="agreement-para">
                                                <span style={{ fontSize: "16px" }}>
                                                    {t("eaconomyIsNotLiable")}
                                                </span>
                                            </p>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    );
};

export default RiskWarning;
